import { render } from "./WidgetOrdersDaily.vue?vue&type=template&id=bf91bb6a&scoped=true&ts=true"
import script from "./WidgetOrdersDaily.vue?vue&type=script&lang=ts"
export * from "./WidgetOrdersDaily.vue?vue&type=script&lang=ts"

import "./WidgetOrdersDaily.vue?vue&type=style&index=0&id=bf91bb6a&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf91bb6a"]])

export default __exports__